import { Address } from 'components/types';

export const getAddressAsString = ({
  streetName,
  houseNumber,
  postalCode,
  city,
  countryCode
}: Address) => {
  const address = [
    `${streetName || ''} ${houseNumber || ''}`.trim(),
    `${postalCode || ''} ${city || ''}`.trim(),
    countryCode !== 'NL' ? `, ${countryCode || ''}` : ''
  ].reduce((a, b) => {
    if (a && b) {
      return `${a}, ${b}`;
    }
    if (a) {
      return a;
    }
    return b;
  });

  return address;
};
